import { render, staticRenderFns } from "./MermaidSyntax.vue?vue&type=template&id=d5f3d1a4&scoped=true"
import script from "./MermaidSyntax.vue?vue&type=script&lang=js"
export * from "./MermaidSyntax.vue?vue&type=script&lang=js"
import style0 from "./MermaidSyntax.vue?vue&type=style&index=0&id=d5f3d1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f3d1a4",
  null
  
)

export default component.exports